<div class="card">
  <img [src]="'https://pssstaticwebstorage.blob.core.windows.net/images/industries/' + tile.imageKey + ' Image.png'" class="card-img-top">
  <div [ngStyle]="{'background-image': barUrl()}" class="card-footer text-white">
    {{tile.bannerText}}
  </div>
</div>
